import { Dispatch, FC, SetStateAction } from 'react';

import CloseOpenSidebarIcon from 'svg/CloseOpenSidebarIcon';

interface ISidePanelToggleButton {
  toggleHandler: Dispatch<SetStateAction<boolean>>;
  isActive: boolean;
  isReverseMode?: boolean;
}

const SidePanelToggleButton: FC<ISidePanelToggleButton> = ({
  toggleHandler,
  isActive,
  isReverseMode = false,
}) => {
  const classIsActive = !isActive ? 'toggle-button-inactive-public' : '';
  const classIsReverse = isReverseMode ? 'toggle-button-reverse' : '';
  const classActiveReverse = !isActive && isReverseMode ? 'toggle-button-inactive-reverse-public' : '';

  return (
    <div className={isReverseMode ? 'd-flex justify-content-end' : ''}>
      <button
        type="button"
        className={`toggle-button ${classIsActive} ${classIsReverse} ${classActiveReverse}`}
        onClick={() => toggleHandler(!isActive)}
      >
        <CloseOpenSidebarIcon />
      </button>
    </div>
  );
};

export default SidePanelToggleButton;